module.exports = __webpack_public_path__ + "static/HSE_Company_Presentation_July_2026-37ab8673d2388c6d53ac8649005aad36.pdf";